import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const p=l("senegal",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5V20.5L0 20.5"
                fill="#E31B23" />
            <path
                d="M0 4.5L16 4.5L16 20.5L0 20.5"
                fill="#FDEF42" />
            <path
                d="M0 4.5L8 4.5L8 20.5L0 20.5"
                fill="#00853F" />
            <path
                d="M9.63922 15.7344L10.5437 13.2551L8.19922 11.7316H11.0996L11.9992 9.26562L12.8989 11.7316H15.7992L13.4547 13.2551L14.3592 15.7344L11.9992 14.2008L9.63922 15.7344Z"
                fill="#00853F" />
        </svg>
    `),d=l("senegal_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_129573)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L24 0.5L24 24.5L0 24.5"
                    fill="#E31B23" />
                <path
                    d="M0 0.5L16 0.5L16 24.5L0 24.5"
                    fill="#FDEF42" />
                <path
                    d="M0 0.5L8 0.5L8 24.5L0 24.5"
                    fill="#00853F" />
                <path
                    d="M9.63922 15.78L10.5437 13.0051L8.19922 11.3H11.0996L11.9992 8.54004L12.8989 11.3H15.7992L13.4547 13.0051L14.3592 15.78L11.9992 14.0637L9.63922 15.78Z"
                    fill="#00853F" />
            </g>
            <defs>
                <clipPath id="clip0_19477_129573">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Senegal,d as SenegalRounded};
